import { useEffect } from 'react';
import { Tooltip } from 'bootstrap';

const TOOLTIP_SELECTOR = '[data-bs-toggle="tooltip"]';

function useTooltipObserver() {
    useEffect(() => {
        function initializeTooltips(root: ParentNode = document) {
            root.querySelectorAll<HTMLElement>(TOOLTIP_SELECTOR)
                .forEach((element) => {
                    Tooltip.getOrCreateInstance(element);
                });
        }

        initializeTooltips();

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (!(node instanceof HTMLElement)) {
                        return;
                    }

                    if (node.matches(TOOLTIP_SELECTOR)) {
                        Tooltip.getOrCreateInstance(node);
                    }

                    initializeTooltips(node);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();

            document
                .querySelectorAll<HTMLElement>(TOOLTIP_SELECTOR)
                .forEach((element) => {
                    Tooltip.getInstance(element)?.dispose();
                });
        };
    }, []);
}

export default useTooltipObserver;
